import { Loading } from "../../utils/helpers/constants";
import * as RemittanceConstants from "../constants/remittance.constant";

const initialState = {
  remittanceFees: [],
  loadingRemittanceFees: "",
  remittanceValuesSettings: [],
  loadingValues: "",
  loadPasswordPolicies: "",
  passwordPolicies: [],
  paymentMethods: [],
  loadingFees: "",
  fixedAmount: [],
  loadingDefaultCharges: "",
};

const remittanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case RemittanceConstants.GET_REMITTANCE_REQUEST:
      return { ...state, loadingRemittanceFees: Loading.FETCHING };

    case RemittanceConstants.GET_REMITTANCE_SUCCESS:
      return {
        ...state,
        loadingRemittanceFees: Loading.SUCCESS,
        remittanceFees: action.payload,
      };

    case RemittanceConstants.GET_REMITTANCE_FAILURE:
      return {
        ...state,
        loadingRemittanceFees: Loading.ERROR,
      };

    case RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_REQUEST:
      return { ...state, loadingValues: Loading.FETCHING };

    case RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_SUCCESS:
      return {
        ...state,
        loadingValues: Loading.SUCCESS,
        remittanceValuesSettings: action.payload,
      };

    case RemittanceConstants.GET_REMITTANCE_SETTINGS_VALUES_FAILURE:
      return { ...state, loadingValues: Loading.ERROR };

    case RemittanceConstants.VIEW_PASSWORD_POLICY_REQUEST:
      return { ...state, loadPasswordPolicies: Loading.FETCHING };

    case RemittanceConstants.VIEW_PASSWORD_POLICY_SUCCESS:
      return {
        ...state,
        loadPasswordPolicies: Loading.SUCCESS,
        passwordPolicies: action.payload,
      };

    case RemittanceConstants.VIEW_PASSWORD_POLICY_FAILURE:
      return { ...state, loadPasswordPolicies: Loading.ERROR };

    case RemittanceConstants.GET_PAYMENT_METHOD_REQUEST:
      return { ...state, loadingFees: Loading.FETCHING };

    case RemittanceConstants.GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loadingFees: Loading.SUCCESS,
        paymentMethods: action.payload,
      };

    case RemittanceConstants.GET_PAYMENT_METHOD_FAILURE:
      return { ...state, loadingFees: Loading.ERROR };

    case RemittanceConstants.GET_FIXED_AMOUNT_FEE_REQUEST:
      return { ...state, loadingDefaultCharges: Loading.FETCHING };

    case RemittanceConstants.GET_FIXED_AMOUNT_FEE_SUCCESS:
      return {
        ...state,
        loadingDefaultCharges: Loading.SUCCESS,
        fixedAmount: action.payload,
      };

    case RemittanceConstants.GET_FIXED_AMOUNT_FEE_FAILURE:
      return { ...state, loadingDefaultCharges: Loading.ERROR };

    default:
      return state;
  }
};

export default remittanceReducer;
